import React from 'react'
import { Text } from "@chakra-ui/core";

const SmallText = props => <Text {...props} fontSize='sm'  />

export default SmallText